'use es6';

import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { Component } from 'react';
import { Button } from 'foundations-components/transitional/components/Button';
import { Link } from 'foundations-components/transitional/components/Link';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import StepInterface from './StepInterface';
import { FINISH_STEP } from 'InboxConnectUtils/constants/InboxConnectStepKeys';
import { INSTALL_PAGE } from 'InboxConnectUtils/utils/Links';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LANG_ROUTE = 'InboxConnectUtils.wizard.finish';
export default class FinishStep extends Component {
  static ActionButton({
    use = 'primary',
    onClick,
    message
  }) {
    return /*#__PURE__*/_jsx(Button, {
      use: use,
      onClick: onClick,
      marginBlockStart: "200",
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: `${LANG_ROUTE}.${message}`
      })
    });
  }
  static ActionBar({
    children
  }) {
    return /*#__PURE__*/_jsx(TFlex, {
      justify: "center",
      direction: "row",
      align: "center",
      wrap: "wrap",
      children: children
    });
  }
  constructor(props) {
    super(props);
    this.handleInstallClicked = this.handleInstallClicked.bind(this);
    this.handleCancelClicked = this.handleCancelClicked.bind(this);
    this.handleDoneClicked = this.handleDoneClicked.bind(this);
  }
  componentDidMount() {
    this.props.trackingClient.trackStepView(FINISH_STEP, this.props.selectedClient);
  }
  handleInstallClicked() {
    const {
      portalId,
      onWizardDone,
      selectedClient
    } = this.props;
    window.open(INSTALL_PAGE(portalId, selectedClient), '_blank');
    this.trackFinishStepAction('click-install-cta');
    onWizardDone();
  }
  handleCancelClicked() {
    this.trackFinishStepAction('click-cancel');
    this.props.onWizardDone();
  }
  handleDoneClicked() {
    this.trackFinishStepAction('click-done');
    this.props.onWizardDone();
  }
  trackFinishStepAction(type) {
    this.props.trackingClient.trackStepAction(FINISH_STEP, type, {});
  }
  renderTitle() {
    const {
      emailAddress
    } = this.props;
    const successWithEmail = () => /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: `${LANG_ROUTE}.nowConnected`,
      options: {
        emailAddress
      }
    });
    const defaultTitle = () => /*#__PURE__*/_jsx(FormattedMessage, {
      message: `${LANG_ROUTE}.title`
    });
    return emailAddress ? successWithEmail() : defaultTitle();
  }
  renderExtensionInstall() {
    const {
      portalId,
      selectedClient
    } = this.props;
    const {
      ActionBar,
      ActionButton
    } = FinishStep;
    return /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(View, {
        marginBlockEnd: "100",
        as: "div",
        children: /*#__PURE__*/_jsx("b", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `${LANG_ROUTE}.install.title`
          })
        })
      }), /*#__PURE__*/_jsx(View, {
        marginBlockEnd: "800",
        as: "div",
        children: /*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(FormattedReactMessage, {
            message: `${LANG_ROUTE}.install.description`,
            options: {
              link: /*#__PURE__*/_jsx(Link, {
                href: INSTALL_PAGE(portalId, selectedClient),
                onClick: () => this.trackFinishStepAction('click-install-link'),
                external: true,
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: `${LANG_ROUTE}.install.downloadExtensionLink`
                })
              })
            }
          })
        })
      }), /*#__PURE__*/_jsxs(ActionBar, {
        children: [/*#__PURE__*/_jsx(ActionButton, {
          message: "downloadLinkButton",
          onClick: this.handleInstallClicked
        }), /*#__PURE__*/_jsx(ActionButton, {
          use: "secondary",
          message: "cancelButton",
          onClick: this.handleCancelClicked
        })]
      })]
    });
  }
  renderStandardFinish() {
    const {
      ActionBar,
      ActionButton
    } = FinishStep;
    return /*#__PURE__*/_jsx(ActionBar, {
      children: /*#__PURE__*/_jsx(ActionButton, {
        message: "button",
        onClick: this.handleDoneClicked
      })
    });
  }
  render() {
    const {
      showExtensionInstall
    } = this.props;
    return /*#__PURE__*/_jsx(Flex, {
      justifyContent: "center",
      alignItems: "center",
      children: /*#__PURE__*/_jsxs(Flex, {
        justifyContent: "center",
        alignItems: "center",
        "data-selenium": "finish-step",
        flexDirection: "column",
        maxInlineSize: "420px",
        children: [/*#__PURE__*/_jsx(Illustration, {
          name: "successfully-connected-email",
          marginBlockEnd: "500",
          blockSize: "100px"
        }), /*#__PURE__*/_jsx(Text, {
          as: "h4",
          marginBlockEnd: "800",
          children: this.renderTitle()
        }), showExtensionInstall ? this.renderExtensionInstall() : this.renderStandardFinish()]
      })
    });
  }
}
FinishStep.propTypes = StepInterface;